"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
const consts_1 = require("./consts");
const ImageUnsupportedType_1 = __importDefault(require("./errors/ImageUnsupportedType"));
const cdn_1 = require("./utils/cdn");
const giphy_1 = require("./utils/giphy");
const GIPHY_REPLACEMENT_URL = 'https://gif.app.senecalearning.com/media/$1/giphy.mp4';
class ImageServiceClient extends client_library_1.Client {
    constructor(fetch, options) {
        super(fetch, options);
        if (!options.cdnBaseUrl) {
            throw new client_library_1.MissingParamError('cdnBaseUrl needs to be provided in options');
        }
        this._cdnBaseUrl = options.cdnBaseUrl;
    }
    /**
     * Given a url with a cdn protocol returns a url for an image that conforms to some options.
     * If this function is given a non CDN url it will simple return it to preserve backward compatibility
     * If the url matches a Giphy url - it will be replaced by a proxy url that will route to the same asset
     */
    getImageUrl(baseUrl, options = {}) {
        if (giphy_1.isGiphyUrl(baseUrl)) {
            return baseUrl.replace(giphy_1.GIPHY_REG_EX, GIPHY_REPLACEMENT_URL);
        }
        if (!baseUrl.startsWith(consts_1.CDN_URL_PROTOCOL)) {
            return baseUrl;
        }
        return cdn_1.parseCdnUrl(baseUrl, this._cdnBaseUrl, options);
    }
    cloneImageByUrl(imageToCloneUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!imageToCloneUrl) {
                throw new client_library_1.MissingParamError('imageUrlToClone must be provided');
            }
            const { clonedImageUrl } = yield this._makeImageRequest('api/clone-url', 'POST', { imageToCloneUrl }, undefined, [201]);
            return cdn_1.getCdnUrl(clonedImageUrl);
        });
    }
    uploadImage(image, contentType, fileName) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!image || !image.data || !image.size) {
                throw new client_library_1.MissingParamError('image.size and image.data must be provided');
            }
            if (!contentType) {
                throw new client_library_1.MissingParamError('contentType must be provided');
            }
            const body = {
                contentType,
                fileName
            };
            const uploadBody = yield this._makeImageRequest('api/upload-url', 'POST', body, undefined, [201]);
            const putRes = yield this.requestMaker.fetch(uploadBody.uploadUrl, {
                method: 'PUT',
                headers: {
                    'Content-Length': image.size,
                    'Content-Type': contentType
                },
                body: image.data
            });
            if (!putRes.ok) {
                throw new client_library_1.UnexpectedServerResponse('PUT', uploadBody.uploadUrl, putRes.status);
            }
            return cdn_1.getCdnUrl(uploadBody.fetchUrl);
        });
    }
    teacherUploadImage(contentType, fileName) {
        return __awaiter(this, void 0, void 0, function* () {
            const body = { contentType, fileName };
            const uploadBody = yield this._makeImageRequest('api/teacher/upload-url', 'POST', body, undefined, [201, 422]);
            if (uploadBody.status === 422) {
                throw new ImageUnsupportedType_1.default(contentType);
            }
            return {
                fetchUrl: cdn_1.getCdnUrl(uploadBody.fetchUrl),
                uploadUrl: uploadBody.uploadUrl
            };
        });
    }
    _makeImageRequest(path, method, body, queryParams, expectedResponses) {
        return __awaiter(this, void 0, void 0, function* () {
            let url = `${this.url}/${path}`;
            if (queryParams) {
                let queryParamParts = [];
                Object.keys(queryParams).forEach(param => {
                    if (queryParams[param]) {
                        queryParamParts.push(`${param}=${queryParams[param]}`);
                    }
                });
                url += `?${queryParamParts.join('&')}`;
            }
            const response = yield this.requestMaker.makeRequest(url, {
                method: method,
                headers: {
                    'Content-Type': 'application/json'
                },
                body: body ? JSON.stringify(body) : undefined
            }, expectedResponses);
            return response.json;
        });
    }
}
exports.default = ImageServiceClient;
